<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="feature-card group">
    <!-- Icon -->
    <div class="w-12 h-12 mb-8" v-html="icon"></div>

    <!-- Content -->
    <div class="space-y-4">
      <h3
        class="text-white font-onest font-semibold text-xl leading-relaxed tracking-tight"
      >
        {{ title }}
      </h3>
      <p
        class="text-white font-onest font-normal text-lg leading-relaxed tracking-tight opacity-90"
      >
        {{ description }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.feature-card {
  @apply bg-white/10 backdrop-blur-sm border border-white/20 rounded-3xl p-8 transition-all duration-300 hover:bg-white/15 hover:border-white/30 hover:transform hover:scale-105;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.feature-card:hover {
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
}
</style>
